export default __webpack_public_path__ + "static/media/5.aaa1db7b.jpeg";